import useLayoutContext from '@views/layouts/hooks/use-context';
import { formatCurrencyVN as format } from '@helpers/format-currency';
import get from 'lodash/get';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';

export function useData() {
  const {
    authenticated,
    checkout: { loading, error, data, selectedGift },
  } = useLayoutContext();

  const cart = get(data, 'checkout.cart', []);
  const promotion = find(
    get(data, 'checkout.promotion.discount', []),
    (value) => get(value, 'canApplyDiscount', false)
  );

  const closedPromotion = find(
    get(data, 'checkout.promotion.discount', []),
    (value) => get(value, 'canApplyDiscount', undefined) === false
  );

  const giftList = get(data, 'checkout.promotion.gift', []);
  const gift = Array.isArray(giftList)
    ? giftList.find(({ id }) => id === get(selectedGift, 'id'))
    : null;

  const quantity = cart?.reduce((node: number, { quantity }) => {
    return node + quantity || 0;
  }, 0);
  // const total = cart.reduce(
  //   (node: number, { quantity, price, isContactProduct }) => {
  //     if (isContactProduct) {
  //       return node;
  //     }

  //     return node + parseInt(quantity || 0) * parseInt(price || 0);
  //   },
  //   0
  // );
  const total = get(data, 'checkout.promotion.totalProductPrice');

  const totalNotEnough = total < 1000000;
  const disabled =
    totalNotEnough ||
    cart?.reduce((node: boolean, { disabled }) => {
      return node || disabled;
    }, false);
  const isFullContactProduct =
    cart.filter((item: any) => get(item, 'isContactProduct')).length ===
    cart.length;
  let discount = 0;
  let discountAmount = get(data, 'checkout.promotion.totalDiscount', 0);
  let grandTotal = total - discountAmount;
  if (!isEmpty(promotion) && !isFullContactProduct) {
    discount = get(promotion, 'discountPercent', 0);

    // if (discount > 0) {
    //   discountAmount = (discount / 100) * total;
    //   grandTotal = total - discountAmount;
    // }
  }

  let closedPrice = 0;
  let closedDiscount = 0;
  if (!isEmpty(closedPromotion) && !isFullContactProduct) {
    closedPrice = get(closedPromotion, 'minPurchase', 0) - total;
    closedDiscount = get(closedPromotion, 'discountPercent', 0);
  }

  return {
    cart,
    loading,
    quantity,
    disabled,
    authenticated,
    closedPrice,
    closedDiscount,
    closedPriceText: format(closedPrice),
    discount,
    gift,
    totalNotEnough,
    discountText: format(discountAmount),
    totalText: isFullContactProduct ? 'Liên hệ' : format(total),
    grandTotalText: isFullContactProduct ? 'Liên hệ' : format(grandTotal),
  };
}
